import * as React from "react";
import { observer } from "mobx-react-lite";
import { Empty, Spin } from "antd";
import { Bom2Cell } from "src/businessServices/services/bsBom2/Bom2Control/Bom2Position/Bom2Table/Bom2Cell";
import styles from "./Bom2aPosSelectTable.module.less";
import { Bom2aPositionsStore } from "../Bom2aPositionsStore";
import { Bom2aPosSelection } from "../Bom2aPositionsTable/components/Bom2aSelection";
import { Bom2aPositionItem } from "../Bom2aPositionsTable/Bom2aPositionItem";

interface PropsBom2aPosSelectTable {
  store: Bom2aPositionsStore;
}

export const Bom2aPosSelectTable: React.FC<PropsBom2aPosSelectTable> = observer(
  ({ store }) => {
    const { positions, columns, columnWidths, collapsed, buzy } = store;
    const gridTemplateColumns = columnWidths.join(" ");
    const isEmpty = positions.length === 0;
    return (
      <div className={styles.table}>
        <div className={styles.thead} style={{ gridTemplateColumns }}>
          {columns.map(({ key, title, minWidth }, i) => (
            <Bom2Cell key={key} top left={i === 0} minWidth={minWidth}>
              {title}
            </Bom2Cell>
          ))}
        </div>
        <div className={styles.tbody} style={{ gridTemplateColumns }}>
          {buzy && (
            <Bom2Cell
              left
              minWidth={undefined}
              style={{ gridColumn: gridColumn(columns.length) }}
            >
              <Spin />
            </Bom2Cell>
          )}
          {!buzy && isEmpty && (
            <Bom2Cell left minWidth={undefined}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </Bom2Cell>
          )}
          {!buzy &&
            !isEmpty &&
            positions.map((pos) => (
              <React.Fragment key={pos.materialTypeId}>
                <Bom2Cell left minWidth={columns[0]?.minWidth}>
                  <Bom2aPosSelection store={store} posId={pos.materialTypeId} />
                </Bom2Cell>
                <Bom2aPositionItem viewMode store={store} position={pos} />

                {!collapsed.has(pos.materialTypeId) &&
                  pos.bomPositionRows.map((row) => (
                    <React.Fragment key={row.id}>
                      {columns.map(({ key, view, minWidth }, i) => (
                        <Bom2Cell key={key} left={i === 0} minWidth={minWidth}>
                          {view(row)}
                        </Bom2Cell>
                      ))}
                    </React.Fragment>
                  ))}
              </React.Fragment>
            ))}
        </div>
      </div>
    );
  },
);

const gridColumn = (n: number) => `span ${n}`;
